export default {
  home: '/clientEcosys/gold/home',
  cityRuleDesc: '/clientEcosys/gold/cityRuleDesc',
  flowLog: '/clientEcosys/gold/flowLog'
}
